<template>
  <div class="wrap">
    <div class="z-flex-c">
      <div class="title">消息提醒</div>
      <div class="icon"><CloseOutlined @click="() => emit('close', index)" /></div>
    </div>
    <div class="content">{{ baseData.warningTipContent }}</div>
    <div class="z-flex-c">
      <div class="time">{{ baseData.dateStr }}</div>
      <a-button type="primary" @click="getWorkOrder">查看详情</a-button>
    </div>
  </div>
</template>
<script setup>
import { CloseOutlined } from '@ant-design/icons-vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { defineProps, defineEmits } from 'vue'
const prop = defineProps({
  index: {
    type: Number,
    default: 0
  },
  baseData: {
    type: Object,
    default: () => {}
  }
})
const router = useRouter()
const store = useStore()
//查看关联工单
const getWorkOrder = () => {
  const path = router?.currentRoute?.value?.path || ''
  if (path === '/todo') {
    store.commit('workOrder/SEARCH_WORK_ORDER', JSON.stringify({ allocationFlag: true }))
  } else {
    router.push({
      path: '/todo',
      query: {
        allocationFlag: true
      }
    })
  }
  emit('close', prop.index)
}

const emit = defineEmits(['close'])
</script>
<style scoped lang="scss">
.wrap {
  padding: 24px;
  background: #ffffff;
  box-shadow: 0 3px 6px -4px #0000001f, 0 6px 16px 0 #00000014, 0 9px 28px 8px #0000000d;
  border-radius: 4px;
  width: 384px;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  margin-top: 3px;
  .title {
    font-weight: 500;
    font-size: 16px;
    color: #000000d9;
  }
  .icon {
    color: #000000a6;
    cursor: pointer;
  }
  .content {
    font-weight: 400;
    font-size: 14px;
    color: #000000a6;
    margin: 12px 0 34px;
  }
}
</style>
